/* global axios */
import ApiClient from './ApiClient';

class DataSyncConfigAPI extends ApiClient {
  constructor() {
    super('data_sync_config', { accountScoped: true });
  }

  getConfig() {
    return this.get();
  }

  updateConfig(payload) {
    return this.update('', payload);
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }
}

export default new DataSyncConfigAPI();
